import { Injector } from '@angular/core';

export let sharedInjector: Injector;

export function setSharedInjector(injector: Injector): void {
  sharedInjector = injector;
}
